<template>
  <div class="container p-0 min-height-medium">
    <HMModalHeader
      :title="$t('GENERAL.TITLE.FOCAL_POINT_PICKER')"
      @close="$emit('close')"
    />
    <div class="text-center">
      <div class="image-wrapper" @mousedown="dragStart">
        <img ref="image" :src="src" class="img-fluid image" />
        <span class="dot" :style="dotStyle"></span>
      </div>
    </div>
    <form @submit.prevent="onConfirm()">
      <HMModalFooter
        :discardButton="$t('GENERAL.BUTTON.CLOSE')"
        @close="$emit('close')"
      >
        <template v-slot:submit>
          <div>
            <HMButton class="mr-3" @click="reset" color="outline-gray">
              {{ $t('GENERAL.BUTTON.RESET') }}
            </HMButton>
            <HMButton type="submit" color="brand">
              {{ $t('GENERAL.BUTTON.APPLY') }}
            </HMButton>
          </div>
        </template>
      </HMModalFooter>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';

function inPercent(value, total) {
  return (value / total) * 100;
}

export default Vue.extend({
  name: 'FocalPointPickerFormModal',
  components: {},
  props: {
    file: {
      type: [Object, String],
    },
    updateThumbnail: {
      type: Boolean,
      default: false,
    },
    confirm: null,
    discard: null,
  },
  data() {
    return {
      x: 50,
      y: 50,
    };
  },
  methods: {
    async onConfirm() {
      const focal_points = {
        focal_point_x: this.x,
        focal_point_y: this.y,
      };
      await this.confirm(this.file, focal_points);
      await this.$emit('close');
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
    dragStart(event) {
      event.preventDefault();
      this.drag(event);
      window.addEventListener('mousemove', this.drag);
      window.addEventListener('mouseup', this.dragEnd);
    },
    dragEnd(event) {
      event.preventDefault();
      window.removeEventListener('mousemove', this.drag);
    },
    drag(e) {
      e.preventDefault();
      const img = this.$refs.image.getBoundingClientRect();
      const pos = {
        x: 0,
        y: 0,
      };
      const x = Math.round(inPercent(e.clientX - img.x, img.width));
      const y = Math.round(inPercent(e.clientY - img.y, img.height));

      if (x <= 0) {
        pos.x = 0;
      } else if (x >= 100) {
        pos.x = 100;
      } else {
        pos.x = x;
      }

      if (y <= 0) {
        pos.y = 0;
      } else if (y >= 100) {
        pos.y = 100;
      } else {
        pos.y = y;
      }
      this.x = pos.x;
      this.y = pos.y;
    },
    reset() {
      this.x = 50;
      this.y = 50;
    },
  },
  computed: {
    src() {
      if (typeof this.file === 'string') {
        return this.file;
      }
      if (this.updateThumbnail) {
        return this.file?.embedded_thumbnail_url || this.file?.thumbnail;
      }
      return (
        this.file?.storage_url ||
        this.file?.embedded_image_url ||
        this.file?.thumbnail
      );
    },
    dotStyle() {
      return {
        left: `calc(${this.x}% - 11px)`,
        top: `calc(${this.y}% - 11px)`,
      };
    },
  },
  mounted() {
    const { focal_point_x, focal_point_y } = this.file;
    this.x = focal_point_x;
    this.y = focal_point_y;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.image-wrapper {
  display: inline-block;
  position: relative;
  z-index: 9;
  cursor: pointer;
  margin-bottom: 1.5rem;
}

.image {
  max-height: 500px;
}

.dot {
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $coral;
}
</style>
